import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { environment } from 'src/environments/environment';
import { MailService } from 'src/app/services/mail.service';
import { MatDialog } from '@angular/material';
import { DialogCommonError } from '../dialogs-errors/dialog-common-error.component';
import { ShowFileDialog } from '../dialogs-show-file/show-file-dialog.component';

@Component({
  selector: 'dossier-init-payslip',
  templateUrl: './dossier-init-payslip.component.html',
  styleUrls: ['./dossier-init-payslip.component.scss']
})
export class DossierInitPayslipComponent implements OnInit {
  sizemaxFile: number = 4194304;
  waiting: number = 0;

  @Output() fileUploaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() uploadingFileChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  // ViewChild
  @ViewChild('uploadDoc', { static: true }) uploadDoc: ElementRef;

  // Variables internes
  fichiersCreation: any[] = [];
  filesInError: any[] = [];
  imgs: any[] = [];
  promise: any = {};
  errorAbbyy: boolean = false;
  uploadingFile: boolean = false;
  creationEvent: any;
  dataFromUploadedFile: any = {};

  constructor(
    private appService: AppService,
    private cdf: ChangeDetectorRef,
    private mailService: MailService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.pload('assets/image/cob-gif-attente.gif');
    this.waiting = environment.waiting;
  }

  // Méthodes internes
  uploadFileCreation(event: FileList) {
    this.creationEvent = event;
    this.uploadingFile = true;
    this.uploadingFileChange.emit(this.uploadingFile);

    if (this.promise && this.promise['uploadfile3'] && this.promise['uploadfile3'].length > 0) {
      return;
    }
    this.promise['uploadfile3'] = [];
    let reco: any[] = [];

    for (let i = 0; i < event.length; i++) {
      const element = event[i];
      reco[i] = {
        datereco: '',
        state: 'En cours de téléchargement.',
        nom: element.name,
        valide: -1,
        failed: false,
        url: '',
      };

      if (element.size >= this.sizemaxFile) {
        reco[i].state = `Votre fichier ${element.name} dépasse la taille autorisée de ${(this.sizemaxFile / (1024 * 1024)).toFixed(2)}Mo.`;
        reco[i].failed = true;
        this.filesInError.push(reco[i]);
      } else {
        this.promise['uploadfile3'].push(
          this.appService.uploadDocument(element, '').toPromise()
            .then((res) => {
              reco[i].url = res.url || '';
              reco[i].nom = res.filename || element.name;
              reco[i].id = res.url || '';
              reco[i].state = res.error_reco ? 'Téléchargement échoué' : 'Téléchargement réussi, validation en cours 30%';
              reco[i].erreur = res.error || '';
              reco[i].nbBulletin = res.validation.result['nombre de Bulletin(s) de salaire'] || '';

              if (res.error_reco === 'Le service d\'Ocr (ABBY) est momentanément indisponible.') {
                this.errorAbbyy = true;
              }

              if (!res.invalide && !res.error && !res.error_reco) {
                this.fileUploaded.emit(res);
              }

              if (this.waiting !== 0) this.percentage(reco[i]);

              if (res.error_reco) {
                if (res.error_reco === 'Le service d\'Ocr (ABBY) est momentanement indisponible.')
                  this.errorAbbyy = true;
                reco[i].state = res.error_reco;
                reco[i].failed = true;
                reco.splice(i, 1);
              }

              if (i + 1 === event.length && this.errorAbbyy) {
                const textError =
                  'Rupture by Cobham rencontre un problème sur l\'un de ses serveurs.\n' +
                  'L\'équipe technique a été avertie et nous reviendrons vers vous le plus rapidement possible.\n\n' +
                  'Pour tout complément d\'informations, contactez-nous à support@cobham-solutions.com\n\n' +
                  'L\'équipe Rupture by Cobham.';
                this.openAbbyyErrorDialogAndSendMail('Erreur Abbyy', 'mailBody', textError);
              }
            })
        )
      }
      Promise.all(this.promise['uploadfile3'])
        .then(() => {
          this.promise['uploadfile3'] = [];
          this.afterUploadCreateFinished(reco[i]);
        })
        .catch((error) => console.log(error));
    }
  }

  afterUploadCreateFinished(fichier: any) {
    this.uploadingFile = false;
    this.uploadingFileChange.emit(this.uploadingFile);
    if (fichier.failed === false) {
      if (fichier.erreur) {
        fichier.valide = 0;
      } else {
        fichier.valide = 1;
      }
      this.fichiersCreation.push(fichier);
    } else {
      this.filesInError.push(fichier);
    }
    this.cdf.detectChanges();
  }

  openAbbyyErrorDialogAndSendMail(subject, mailBody, textError) {
    this.mailService.sendMailToSupport(subject, mailBody).subscribe(() => {
      this.dialog.open(DialogCommonError, {
        width: '100%',
        panelClass: 'error-dialog',
        data: textError,
      });
    });
  }

  removeBulletinCreation() {
    this.fichiersCreation = [];
    this.fileUploaded.emit(null);
  }

  removeFileInError(file: any) {
    const index = this.filesInError.indexOf(file);
    if (index > -1) this.filesInError.splice(index, 1);
  }

  showFile(file: string) {

    let fileurl = ''
    let pdfOk = true;
    let pdfExt: RegExp = /\.pdf$/;
    let page;

    if (file[1]) {
      if (file[1]['urlfront']) {
        fileurl = file[1]['urlfront']
      } else {
        fileurl = file[0]['url']
      }
      pdfExt.test(file[0]['nom']) ? pdfOk = true : pdfOk = false;
      page = file[1]['page'] ? file[1]['page'] : 1;
    } else {
      if (file["urlfront"]) {
        fileurl = file["urlfront"];
      } else {
        fileurl = file["url"];
      }
      pdfExt.test(file['nom']) ? pdfOk = true : pdfOk = false;
      page = file['page'] ? file['page'] : 1;
    }

    //pdfExt.test(fileurl) ? pdfOk = true : pdfOk = false;
    const dialogRef = this.dialog.open(ShowFileDialog, {
      width: '100%',
      panelClass: 'viewpdf-dialog',
      data: {
        url: fileurl,
        pdf: pdfOk,
        name: file[0] ? file[0]['nom'] : file['nom'],
        page: page
      }
    });
  }

  // Helpers internes
  pload(...args: string[]): void {
    this.imgs = [];
    for (let i = 0; i < args.length; i++) {
      this.imgs[i] = new Image();
      this.imgs[i].src = args[i];
    }
  }

  percentage(fichier: any) {
    setTimeout(() => {
      this.waiting -= 200;
      let perc = (((environment.waiting - this.waiting) / environment.waiting) * 70) + 30;
      if (perc > 100) perc = 100;
      if (!fichier.failed) fichier.state = `Téléchargement réussi, validation en cours ${perc}%`;
      this.percentage(fichier);
    }, 200);
  }
}